module.exports = __webpack_public_path__ + "static/media/eCarIcon.010fce82.svg";